// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tidal-footer[data-v-c5fc9f32]{outline:0}@media(min-width: 768px){.tidal-footer-line[data-v-c5fc9f32]{border-top:1px solid rgba(255,255,255,.1)}}.tidal-footer-slot[data-v-c5fc9f32]{line-height:3.5rem}@media(min-width: 768px){.tidal-footer-links[data-v-c5fc9f32]{line-height:5}}@media(min-width: 768px){.inline-block-md-min[data-v-c5fc9f32]{display:inline-block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
